import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * Public API: apply a promo code to a store cart.
 * @const ApplyPromoCodeMutation
 * @since 1.0.0
 */
export const ApplyPromoCodeMutation = gql `
  mutation ApplyPromoCodeMutation($input: ApplyPromoCodeInput!) {
    applyPromoCode(input: $input) {
      ...DealFragment
    }
  }

  ${DealFragment}
`;
